export default __webpack_public_path__ + "static/media/loudly-crying-face.296f0a26.png";